// pages/chat/chat.component.jsx
import GroupChatDialog from "../../components/meet/GroupChatDialog";
import {
  chatAction,
  chatKey,
  setChatMuted,
  leaveChatGroup,
  muteUser,
  unMuteUser,
  blockUser,
  unblockUser,
} from "../../firebase/chatPreferences";
// pages/chat.component.jsx
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  db,
  createMessageToWorkspace,
  createMessageToProject,
  createMessageToPerson,
  getConversationId,
  listenToConversationMessages,
  deleteConversationMessage,
} from "../../firebase/firebase.utils";
import uploadFile from "../../utils/uploadFile";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { motion } from "framer-motion";

import { setConnectedUsers } from "../../redux/user/user.actions";

import Report from "../../components/report/Report";
import { createReport } from "../../components/report/createReport";

import TinyContextMenu from "../../components/tiny-context-menu/TinyContextMenu";

import { useActiveSpaceData } from "../../hooks/useActiveSpaceData.hook";

import GroupMeeting from "../../components/meet/GroupMeeting";
import { useCollabProjects } from "../../components/collab-projects/CollabProjectsProvider";

import RetroButton from "../../components/retro/button/retro-button.component";
import Avatar from "../../components/retro/avatar/avatar.component";
import Message from "../../components/message/message.component";

import ReactionSummary from "../../components/reactions/ReactionSummary";
import { setMyReactionOnDoc } from "../../components/reactions/reactionHelpers";

import {
  ChatMessageAttachments,
  LocationAttachmentModal,
  PendingChatAttachments,
} from "../../components/chat-attachments/chat-attachments.component";

import { Tooltip } from "react-tooltip";

import {
  BsEmojiSmileUpsideDown,
  BsTrash,
  BsPersonCheck,
  BsFullscreen,
  BsFullscreenExit,
  BsExclamationCircleFill,
} from "react-icons/bs";
import { FiArrowLeft, FiChevronRight, FiChevronDown } from "react-icons/fi";
import { IoMdChatboxes } from "react-icons/io";
import {
  IoAttach,
  IoDocumentAttachOutline,
  IoEllipsisVertical,
  IoImageOutline,
  IoLocationOutline,
  IoPeopleOutline,
  IoVideocamOutline,
} from "react-icons/io5";
import { MdDeleteOutline, MdHistory } from "react-icons/md";
import { AiOutlineFullscreen, AiOutlineShareAlt } from "react-icons/ai";
import {
  HiOutlineArrowUturnLeft,
  HiOutlineChatBubbleLeftEllipsis,
  HiXMark,
} from "react-icons/hi2";
import { FaPaperPlane, FaInfoCircle } from "react-icons/fa";

import Peep from "../../components/avatar-creator/Peep";
import ChatReactionPicker from "../../components/chat-reaction-picker/ChatReactionPicker";

import "./chat.styles.scss";

const PAGE_SIZE = 15;
const MAX_ATTACHMENTS = 10;
const IMAGE_MAX_WIDTH = 1600;
const IMAGE_QUALITY = 0.8;
const VIDEO_MAX_SECONDS = 60;
const VIDEO_MAX_BYTES = 50 * 1024 * 1024;
const ALLOWED_FILE_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
];

const createLocalId = () =>
  `${Date.now()}_${Math.random().toString(16).slice(2)}`;

const EMPTY_PEOPLE = [];

function Chat() {
  const [reportTarget, setReportTarget] = useState(null);
  const scopedUsers = useSelector((state) => state.user.users) || EMPTY_PEOPLE;
  const connectedUsers =
    useSelector((state) => state.user.connectedUsers) || EMPTY_PEOPLE;

  const spaceData = useSelector((state) => state.space.spaceData);
  const { allProjects } = useCollabProjects();
  const collabChatProjects = useMemo(() => {
    const workspaceIds = new Set(
      (spaceData || []).map((space) => space.spaceId),
    );
    return allProjects
      .filter((project) => !workspaceIds.has(project.spaceId))
      .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  }, [spaceData, allProjects]);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [chatIsOpen, SetChatIsOpen] = useState(false);
  const [chatx, setChatX] = useState("-320px");
  const activeSpaceData = useActiveSpaceData();
  const currentUser = useSelector((state) => state.user.currentUser);
  const currentUserAvatar = currentUser?.imgAvatar;
  // Contacts remain a separate Redux list; chat can resolve either kind of person.
  const users = useMemo(
    () => [
      ...new Map(
        [...connectedUsers, ...scopedUsers, currentUser]
          .filter((person) => person?.uid || person?.id)
          .map((person) => [
            person.uid || person.id,
            { ...person, uid: person.uid || person.id },
          ]),
      ).values(),
    ],
    [connectedUsers, scopedUsers, currentUser],
  );

  const [msgs, setMsgs] = useState([]);
  const [projectMsgs, setProjectMsgs] = useState([]);
  const [personalMsgs, setPersonalMsgs] = useState([]);
  const [chatmessage, setChatMessage] = useState("");

  const location = useLocation();
  const currentSpaceId = location.pathname.split("/")[2];
  const currentStationId = location.pathname.split("/")[4];

  const textareaRef = useRef();
  const messagesListRef = useRef(null);
  const olderMessagesTriggerRef = useRef(null);
  const loadingOlderRef = useRef(false);
  const messageRefs = useRef({});
  const highlightTimeoutRef = useRef(null);
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const attachmentsRef = useRef([]);
  const attachmentControlRef = useRef(null);
  const composerPickerButtonRef = useRef(null);
  const messageActionMenuRefs = useRef({});

  const [memberData, setMemberData] = useState([]);

  const [chatPicker, setChatPicker] = useState(null);
  const [sendtomode, setSendtomode] = useState("");
  const [sendto, setSendto] = useState(null);
  const [sendtoWsId, setSendtoWsId] = useState(null);
  const [currentStationName, setCurrentStationName] = useState("");
  const [currentStationIcon, setCurrentStationIcon] = useState("");
  const [buttonlook, setButtonLook] = useState("nopersonselected");
  const [contactsopen, setContactsOpen] = useState(false);
  const [currentrecipient, setCurrentRecipient] = useState("");
  const [meetingFullScreen, setMeetingFullScreen] = useState(false);
  const [showInstantChat, setShowInstantChat] = useState(true);

  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState("");
  const [projectOptionsWorkspaceId, setProjectOptionsWorkspaceId] =
    useState(null);
  const projectOptions = useMemo(
    () =>
      allProjects.filter(
        (project) => project.spaceId === projectOptionsWorkspaceId,
      ),
    [allProjects, projectOptionsWorkspaceId],
  );

  const [showGroupSelect, setShowGroupSelect] = useState(false);
  const [privacyGroup, setPrivacyGroup] = useState(null);
  const privacyBusy = useRef(false);
  const [selectedGroupName, setSelectedGroupName] = useState(null);
  const [selectedGroupColor, setSelectedGroupColor] = useState(null);
  const [selectedGroupIcon, setSelectedGroupIcon] = useState(null);

  const [showExtras, setShowExtras] = useState(false);
  const [showExtrasFor, setShowExtrasFor] = useState(null);
  const [aboutToBlock, setAboutToBlock] = useState(null);

  const [onCall, setOnCall] = useState(false);

  const [messageLimit, setMessageLimit] = useState(PAGE_SIZE);
  const [loadingOlder, setLoadingOlder] = useState(false);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);

  const [replyingTo, setReplyingTo] = useState(null);
  const [replyMessageCache, setReplyMessageCache] = useState({});
  const [pendingScrollMessageId, setPendingScrollMessageId] = useState(null);
  const [flashingMessageId, setFlashingMessageId] = useState(null);

  const [attachments, setAttachments] = useState([]);
  const [uploadMap, setUploadMap] = useState({});
  const [publishingMsg, setPublishingMsg] = useState("");
  const [showAttachmentOptions, setShowAttachmentOptions] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);

  const [connectedUsersOpen, setConnectedUsersOpen] = useState(false);
  const [collabUsersOpen, setCollabUsersOpen] = useState(false);
  const [collabProjectsOpen, setCollabProjectsOpen] = useState(true);

  const wschat = searchParams.get("wschat");
  const prchat = searchParams.get("prchat");
  const dmchat = searchParams.get("dmchat");

  // Being used for prchat to get the full address to navigate to.
  const fromws = searchParams.get("fromws");

  const convId = getConversationId(currentUser?.uid, sendto);

  const callSpaceId =
    sendtomode === "toworkspace" ? sendto : sendtoWsId || selectedWorkspaceId;
  const callProject =
    sendtomode === "toproject"
      ? allProjects.find(
          (project) =>
            project.stationId === sendto && project.spaceId === callSpaceId,
        )
      : null;
  const callWorkspace = spaceData?.find(
    (space) => space.spaceId === callSpaceId,
  );
  const callRecipientIds =
    sendtomode === "toperson"
      ? [sendto]
      : [
          ...new Set(
            [...(callWorkspace?.members || []), ...(callProject?.members || [])]
              .map((person) =>
                typeof person === "string"
                  ? person
                  : person?.uid || person?.userId || person?.id,
              )
              .filter(Boolean),
          ),
        ];

  const activeChatKey =
    sendtomode === "toproject"
      ? `${sendtomode}:${selectedWorkspaceId}:${sendto}`
      : `${sendtomode}:${sendto}`;

  const activeMessages = useMemo(() => {
    if (sendtomode === "toworkspace") return msgs;
    if (sendtomode === "toproject") return projectMsgs;
    if (sendtomode === "toperson") return personalMsgs;
    return [];
  }, [sendtomode, msgs, projectMsgs, personalMsgs]);

  const activeMessagesCollection = useMemo(() => {
    if (sendtomode === "toworkspace" && sendto) {
      return db.collection("space").doc(sendto).collection("chats");
    }

    if (sendtomode === "toproject" && selectedWorkspaceId && sendto) {
      return db
        .collection("space")
        .doc(selectedWorkspaceId)
        .collection("stations")
        .doc(sendto)
        .collection("chats");
    }

    if (sendtomode === "toperson" && convId) {
      return db.collection("conversations").doc(convId).collection("messages");
    }

    return null;
  }, [sendtomode, sendto, selectedWorkspaceId, convId]);

  useEffect(() => {
    if (wschat?.length > 0) {
      SetChatIsOpen(true);
      setSelectedWorkspaceId(wschat);
      setSendtomode("toworkspace");
      setSendto(wschat);
      const matchingSpace = spaceData.find((s) => s.spaceId === wschat);
      setSelectedGroupName(matchingSpace?.name || "not found");
      setSelectedGroupColor(matchingSpace?.color || "#dddddd");
    }

    if (prchat?.length > 0) {
      SetChatIsOpen(true);

      if (!fromws) {
        setSendtomode("toproject");
        setSendto(prchat);
      }

      if (fromws) {
        const docRef = db
          .collection("space")
          .doc(fromws)
          .collection("stations")
          .doc(prchat);

        docRef
          .get()
          .then((doc) => {
            if (doc.exists) {
              console.log("Document data:", doc.data());
              const refProject = { id: doc.id, ...doc.data() };
              setSelectedWorkspaceId(fromws);
              setSendtomode("toproject");
              setButtonLook("nopersonselected");
              setSendto(refProject.id);
              setSendtoWsId(fromws);
              setShowGroupSelect(false);
              setSelectedGroupName(refProject.name);
              setSelectedGroupIcon(refProject.emojicon);
            } else {
              console.log("No such document!");
            }
          })
          .catch((error) => {
            console.log("Error getting document:", error);
          });
      }
    }

    if (dmchat?.length > 0 && currentUser?.uid) {
      SetChatIsOpen(true);
      setSendtomode("toperson");

      const findSendto = () => {
        const convertedConvId = dmchat.replace(currentUser.uid, "");
        const recipient = users.find(
          (person) => person.uid === convertedConvId,
        );
        setSendto(convertedConvId);
        setButtonLook("personselected");
        setCurrentRecipient(recipient);
      };

      findSendto();
    }
  }, [
    users,
    wschat,
    prchat,
    dmchat,
    fromws,
    currentUser?.uid,
    currentStationIcon,
    spaceData,
  ]);

  useEffect(() => {
    const memberIds = new Set(
      [
        ...(spaceData || []).flatMap((space) => space.members || []),
        ...allProjects.flatMap((project) => project.members || []),
      ].map((person) =>
        typeof person === "string"
          ? person
          : person?.uid || person?.userId || person?.id,
      ),
    );
    setMemberData(users.filter((person) => memberIds.has(person.uid)));
  }, [spaceData, allProjects, users]);

  useEffect(() => {
    const uid = currentUser?.uid;
    dispatch(setConnectedUsers([]));
    if (!uid) return;
    let active = true;
    let request = 0;
    const unsubscribe = db
      .collection("connections")
      .where("uids", "array-contains", uid)
      .onSnapshot(
        async (snap) => {
          const currentRequest = ++request;
          try {
            const ids = [
              ...new Set(
                snap.docs.flatMap((doc) =>
                  (doc.data().uids || []).filter((id) => id !== uid),
                ),
              ),
            ];
            const people = await Promise.all(
              ids.map(async (id) => {
                const snap = await db.collection("users").doc(id).get();
                return snap.exists
                  ? { ...snap.data(), id: snap.id, uid: snap.id }
                  : null;
              }),
            );
            if (active && currentRequest === request)
              dispatch(setConnectedUsers(people.filter(Boolean)));
          } catch (error) {
            if (active && currentRequest === request) {
              dispatch(setConnectedUsers([]));
              console.error("Connected profiles could not be loaded:", error);
            }
          }
        },
        (error) => {
          request += 1;
          if (active) {
            dispatch(setConnectedUsers([]));
            console.error("Connections could not be loaded:", error);
          }
        },
      );
    return () => {
      active = false;
      request += 1;
      unsubscribe();
    };
  }, [currentUser?.uid, dispatch]);

  // Read current station name.
  useEffect(() => {
    if (!currentStationId) return;

    const unsub = db
      .collection("space")
      .doc(currentSpaceId)
      .collection("stations")
      .doc(currentStationId)
      .onSnapshot((docSnap) => {
        const stationNameRef = docSnap.data().name;
        const stationIconRef = docSnap.data().emojicon;
        setCurrentStationName(stationNameRef);
        setCurrentStationIcon(stationIconRef);
      });

    return () => unsub();
  }, [currentSpaceId, currentStationId]);

  useEffect(() => {
    if (currentUser?.onCall) {
      SetChatIsOpen(true);
      setSendtomode("toperson");
      setSendto(currentUser.onCall);
      setButtonLook("personselected");
    }
  }, [currentUser?.onCall]);

  useEffect(() => {
    if (currentUser?.onCall) {
      const currentrecipientref = memberData?.filter(
        (member) => member?.uid === currentUser?.onCall,
      );
      setCurrentRecipient(currentrecipientref[0]);
    }
  }, [currentUser?.onCall, memberData, personalMsgs]);

  useEffect(() => {
    attachmentsRef.current = attachments;
  }, [attachments]);

  useEffect(() => {
    if (!showAttachmentOptions) return;

    const handleOutsidePress = (event) => {
      const clickedAttachmentControl = attachmentControlRef.current?.contains(
        event.target,
      );
      if (!clickedAttachmentControl) {
        setShowAttachmentOptions(false);
      }
    };

    document.addEventListener("mousedown", handleOutsidePress);
    return () => document.removeEventListener("mousedown", handleOutsidePress);
  }, [showAttachmentOptions]);

  useEffect(() => {
    return () => {
      attachmentsRef.current.forEach((attachment) => {
        if (attachment.localUrl) URL.revokeObjectURL(attachment.localUrl);
      });
    };
  }, []);

  const clearPendingAttachments = () => {
    attachmentsRef.current.forEach((attachment) => {
      if (attachment.localUrl) URL.revokeObjectURL(attachment.localUrl);
    });

    attachmentsRef.current = [];
    setAttachments([]);
    setUploadMap({});
  };

  const addAttachments = (newAttachments) => {
    const availableSlots = MAX_ATTACHMENTS - attachments.length;

    if (availableSlots <= 0) {
      alert(`You can add up to ${MAX_ATTACHMENTS} attachments.`);
      return;
    }

    if (newAttachments.length > availableSlots) {
      alert(
        `Only ${availableSlots} more attachment${
          availableSlots === 1 ? "" : "s"
        } can be added.`,
      );
    }

    newAttachments.slice(availableSlots).forEach((attachment) => {
      if (attachment.localUrl) URL.revokeObjectURL(attachment.localUrl);
    });

    setAttachments((currentAttachments) => [
      ...currentAttachments,
      ...newAttachments.slice(0, availableSlots),
    ]);
  };

  const makeGifAttachment = (gif) => ({
    id: createLocalId(),
    kind: "gif",
    provider: "klipy",
    providerId: gif.id || null,
    slug: gif.slug || null,
    title: gif.title || "GIF",
    url: gif.url,
    previewUrl: gif.previewUrl || gif.url,
    width: gif.width || null,
    height: gif.height || null,
    sourceUrl: gif.sourceUrl || null,
    creator: gif.creator || null,
    contentSource: gif.contentSource || null,
  });

  const resizeImageFile = (file) =>
    new Promise((resolve, reject) => {
      const localUrl = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        const ratio = Math.min(1, IMAGE_MAX_WIDTH / image.width);
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(image.width * ratio);
        canvas.height = Math.round(image.height * ratio);

        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(localUrl);

            if (!blob) {
              reject(new Error("Could not prepare image"));
              return;
            }

            resolve(
              new File([blob], `${file.name.replace(/\.[^.]+$/, "")}.jpg`, {
                type: "image/jpeg",
              }),
            );
          },
          "image/jpeg",
          IMAGE_QUALITY,
        );
      };

      image.onerror = () => {
        URL.revokeObjectURL(localUrl);
        reject(new Error("Could not read image"));
      };

      image.src = localUrl;
    });

  const readVideoDuration = (file) =>
    new Promise((resolve, reject) => {
      const localUrl = URL.createObjectURL(file);
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        URL.revokeObjectURL(localUrl);
        resolve(Number.isFinite(video.duration) ? video.duration : null);
      };

      video.onerror = () => {
        URL.revokeObjectURL(localUrl);
        reject(new Error("Could not read video"));
      };

      video.src = localUrl;
    });

  const handleImageFiles = (event) => {
    const files = [...(event.target.files || [])].filter((file) =>
      file.type.startsWith("image/"),
    );

    addAttachments(
      files.map((file) => ({
        id: createLocalId(),
        kind: "image",
        file,
        localUrl: URL.createObjectURL(file),
      })),
    );

    event.target.value = "";
  };

  const handleVideoFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";

    if (!file) return;

    const isMp4 =
      file.type === "video/mp4" || file.name.toLowerCase().endsWith(".mp4");

    if (!isMp4) {
      alert("Please choose an MP4 video for mobile compatibility.");
      return;
    }

    if (file.size > VIDEO_MAX_BYTES) {
      alert("Please choose a video smaller than 50 MB.");
      return;
    }

    try {
      const durationSeconds = await readVideoDuration(file);

      if (durationSeconds && durationSeconds > VIDEO_MAX_SECONDS) {
        alert("Please choose a video under 60 seconds.");
        return;
      }

      addAttachments([
        {
          id: createLocalId(),
          kind: "video",
          file,
          localUrl: URL.createObjectURL(file),
          durationMs: durationSeconds
            ? Math.round(durationSeconds * 1000)
            : null,
          fileSize: file.size,
          thumbUrl: null,
        },
      ]);
    } catch (error) {
      alert(error.message || "Could not read video.");
    }
  };

  const handleFile = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";

    if (!file) return;

    const ext = file.name.includes(".")
      ? file.name.split(".").pop().toLowerCase()
      : "";

    if (!ALLOWED_FILE_EXTENSIONS.includes(ext)) {
      alert("Please choose a PDF, Word, Excel, or PowerPoint file.");
      return;
    }

    addAttachments([
      {
        id: createLocalId(),
        kind: "file",
        file,
        name: file.name,
        mimeType: file.type || "application/octet-stream",
        size: file.size,
        ext,
      },
    ]);
  };

  const shareLocation = () => {
    setShowAttachmentOptions(false);

    if (attachments.length >= MAX_ATTACHMENTS) {
      alert(`You can add up to ${MAX_ATTACHMENTS} attachments.`);
      return;
    }

    if (!navigator.geolocation) {
      alert("Location sharing is not supported by this browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        setPendingLocation({
          latitude: coords.latitude,
          longitude: coords.longitude,
        });
      },
      (error) => {
        alert(error.message || "Could not get your location.");
      },
      {
        enableHighAccuracy: false,
        timeout: 12000,
        maximumAge: 60000,
      },
    );
  };

  const confirmLocation = (location) => {
    addAttachments([
      {
        id: createLocalId(),
        kind: "location",
        ...location,
      },
    ]);
    setPendingLocation(null);
  };

  const removeAttachment = (attachmentId) => {
    setAttachments((currentAttachments) => {
      const removedAttachment = currentAttachments.find(
        (attachment) => attachment.id === attachmentId,
      );

      if (removedAttachment?.localUrl) {
        URL.revokeObjectURL(removedAttachment.localUrl);
      }

      return currentAttachments.filter(
        (attachment) => attachment.id !== attachmentId,
      );
    });

    setUploadMap((currentMap) => {
      const nextMap = { ...currentMap };
      delete nextMap[attachmentId];
      return nextMap;
    });
  };

  const moveAttachment = (attachmentId, direction) => {
    setAttachments((currentAttachments) => {
      const currentIndex = currentAttachments.findIndex(
        (attachment) => attachment.id === attachmentId,
      );
      const nextIndex =
        direction === "left" ? currentIndex - 1 : currentIndex + 1;

      if (
        currentIndex < 0 ||
        nextIndex < 0 ||
        nextIndex >= currentAttachments.length
      ) {
        return currentAttachments;
      }

      const reordered = [...currentAttachments];
      [reordered[currentIndex], reordered[nextIndex]] = [
        reordered[nextIndex],
        reordered[currentIndex],
      ];
      return reordered;
    });
  };

  const setAttachmentProgress = (attachmentId, progress) => {
    setUploadMap((currentMap) => ({
      ...currentMap,
      [attachmentId]: {
        ...(currentMap[attachmentId] || {}),
        ...progress,
      },
    }));
  };

  const uploadOneAttachment = async (attachment, messageId) => {
    if (
      attachment.kind === "location" ||
      attachment.kind === "gif" ||
      attachment.kind === "sticker"
    ) {
      const { localUrl, file, ...cleanRemoteAttachment } = attachment;
      return cleanRemoteAttachment;
    }

    setAttachmentProgress(attachment.id, {
      phase: "processing",
      progress: 0,
    });

    const file =
      attachment.kind === "image"
        ? await resizeImageFile(attachment.file)
        : attachment.file;
    const ext =
      attachment.kind === "image"
        ? "jpg"
        : attachment.kind === "video"
          ? "mp4"
          : attachment.ext || "file";
    const contentType =
      attachment.kind === "image"
        ? "image/jpeg"
        : attachment.kind === "video"
          ? "video/mp4"
          : attachment.mimeType || "application/octet-stream";
    const storagePath = `users/${currentUser.uid}/shared/chat/${messageId}/${attachment.id}.${ext}`;

    let url;

    try {
      ({ url } = await uploadFile({
        file,
        fullPath: storagePath,
        contentType,
        userId: currentUser.uid,
        onProgress: ({ progress }) => {
          setAttachmentProgress(attachment.id, {
            phase: "uploading",
            progress,
          });
        },
      }));
    } catch (error) {
      setAttachmentProgress(attachment.id, {
        phase: "error",
        progress: 0,
      });
      throw error;
    }

    setAttachmentProgress(attachment.id, {
      phase: "done",
      progress: 1,
    });

    const { localUrl, file: originalFile, ...cleanAttachment } = attachment;

    return {
      ...cleanAttachment,
      url,
      thumbUrl: attachment.thumbUrl || null,
      storagePath,
      thumbStoragePath: null,
    };
  };

  const uploadChatAttachments = async (messageId) => {
    const results = await Promise.allSettled(
      attachments.map(async (attachment) => {
        try {
          return await uploadOneAttachment(attachment, messageId);
        } catch (error) {
          setAttachmentProgress(attachment.id, { phase: "error", progress: 0 });
          throw error;
        }
      }),
    );
    const failed = results.find((result) => result.status === "rejected");
    if (failed) throw failed.reason;
    return results.map((result) => result.value);
  };

  const sendPreparedMessage = async ({
    text,
    preparedAttachments = [],
    repliedToId = null,
  }) => {
    if (!sendtomode || !sendto || !currentUser?.uid) return false;

    if (sendtomode === "toworkspace") {
      await createMessageToWorkspace(
        text,
        currentUser.uid,
        sendto,
        sendtomode,
        currentUser?.userName,
        currentUser.imageUrl,
        selectedGroupName,
        repliedToId,
        preparedAttachments,
      );
    }

    if (sendtomode === "toproject") {
      await createMessageToProject(
        sendtoWsId,
        text,
        currentUser.uid,
        sendto,
        sendtomode,
        currentUser?.userName,
        currentUser?.imageUrl,
        selectedGroupName,
        repliedToId,
        preparedAttachments,
      );
    }

    if (sendtomode === "toperson") {
      await createMessageToPerson(
        text,
        currentUser.uid,
        sendto,
        currentUser?.userName,
        currentUser?.imageUrl,
        repliedToId,
        preparedAttachments,
      );
    }

    return true;
  };

  const makeStickerAttachment = (stickerKey) => ({
    id: createLocalId(),
    kind: "sticker",
    key: stickerKey,
  });

  const sendPickerMessage = async ({
    emojiObject = null,
    stickerKey = null,
    gif = null,
    repliedToId = null,
  }) => {
    if (publishingMsg) return;
    if (
      sendtomode === "toperson" &&
      (currentUser?.blockedUsers?.includes(sendto) ||
        currentrecipient?.blockedUsers?.includes(currentUser?.uid))
    ) {
      window.alert(
        "Direct messages and calls are unavailable while either person has blocked the other.",
      );
      return;
    }

    if (!sendtomode || !sendto || !currentUser?.uid) return;

    const currentText = chatmessage.trim();
    const emoji = emojiObject?.native || "";
    const text = emoji
      ? currentText
        ? `${currentText} ${emoji}`
        : emoji
      : currentText;

    const preparedAttachments = gif
      ? [makeGifAttachment(gif)]
      : stickerKey
        ? [makeStickerAttachment(stickerKey)]
        : [];

    try {
      setPublishingMsg(
        gif
          ? "Sending GIF..."
          : stickerKey
            ? "Sending sticker..."
            : "Sending...",
      );

      await sendPreparedMessage({
        text,
        repliedToId,
        preparedAttachments,
      });

      // Picker messages are immediate. Existing local file attachments remain
      // pending for the user's next regular message.
      setChatMessage("");
      setReplyingTo(null);
      setShowAttachmentOptions(false);
      setChatPicker(null);
      textareaRef.current?.focus();
    } catch (error) {
      console.log("Could not send picker message:", error);
      alert(error.message || "Could not send message. Please try again.");
    } finally {
      setPublishingMsg("");
    }
  };

  const getMessageDocRef = (messageId) => {
    if (sendtomode === "toworkspace" && sendto) {
      return db
        .collection("space")
        .doc(sendto)
        .collection("chats")
        .doc(messageId);
    }

    if (sendtomode === "toproject" && selectedWorkspaceId && sendto) {
      return db
        .collection("space")
        .doc(selectedWorkspaceId)
        .collection("stations")
        .doc(sendto)
        .collection("chats")
        .doc(messageId);
    }

    if (sendtomode === "toperson" && convId) {
      return db
        .collection("conversations")
        .doc(convId)
        .collection("messages")
        .doc(messageId);
    }

    return null;
  };

  const rectSnapshot = (element) => {
    const rect = element?.getBoundingClientRect?.();
    if (!rect) return null;

    return {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height,
    };
  };

  const openComposerPicker = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (publishingMsg) return;
    if (
      sendtomode === "toperson" &&
      (currentUser?.blockedUsers?.includes(sendto) ||
        currentrecipient?.blockedUsers?.includes(currentUser?.uid))
    ) {
      window.alert(
        "Direct messages and calls are unavailable while either person has blocked the other.",
      );
      return;
    }

    if (chatPicker?.purpose === "composer") {
      setChatPicker(null);
      return;
    }

    setShowAttachmentOptions(false);
    setChatPicker({
      purpose: "composer",
      message: null,
      anchorRect: rectSnapshot(composerPickerButtonRef.current),
      initialTab: "emoji",
    });
  };

  const openMessagePicker = (message) => {
    setChatPicker({
      purpose: "message",
      message,
      anchorRect: rectSnapshot(messageRefs.current[message.id]),
      initialTab: "emoji",
    });
  };

  const handlePickerEmoji = async (emojiObject) => {
    if (chatPicker?.purpose === "message" && chatPicker.message) {
      const docRef = getMessageDocRef(chatPicker.message.id);
      setChatPicker(null);

      if (docRef) {
        await setMyReactionOnDoc(docRef, currentUser?.uid, emojiObject.native);
      }
      return;
    }

    await sendPickerMessage({
      emojiObject,
      repliedToId: replyingTo?.id || null,
    });
  };

  const handlePickerSticker = async (stickerKey) => {
    await sendPickerMessage({
      stickerKey,
      repliedToId:
        chatPicker?.purpose === "message"
          ? chatPicker.message?.id || null
          : replyingTo?.id || null,
    });
  };

  const handlePickerGif = async (gif) => {
    await sendPickerMessage({
      gif,
      repliedToId:
        chatPicker?.purpose === "message"
          ? chatPicker.message?.id || null
          : replyingTo?.id || null,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (publishingMsg) return;
    if (
      sendtomode === "toperson" &&
      (currentUser?.blockedUsers?.includes(sendto) ||
        currentrecipient?.blockedUsers?.includes(currentUser?.uid))
    ) {
      window.alert(
        "Direct messages and calls are unavailable while either person has blocked the other.",
      );
      return;
    }

    const text = chatmessage.trim();

    if (!text && attachments.length === 0) {
      alert("Add a message or an attachment first.");
      return;
    }

    if (!sendtomode || !sendto || !currentUser?.uid) return;

    const repliedToId = replyingTo?.id || null;
    const messageId = createLocalId();

    try {
      const hasUploadableAttachments = attachments.some((attachment) =>
        ["image", "video", "file"].includes(attachment.kind),
      );

      setPublishingMsg(
        hasUploadableAttachments
          ? "Uploading attachments..."
          : "Sending message...",
      );

      const uploadedAttachments = await uploadChatAttachments(messageId);
      setPublishingMsg("Sending message...");

      await sendPreparedMessage({
        text,
        repliedToId,
        preparedAttachments: uploadedAttachments,
      });

      setChatMessage("");
      setReplyingTo(null);
      clearPendingAttachments();
    } catch (error) {
      console.log("Could not send chat attachment:", error);
      alert(error.message || "Could not send message. Please try again.");
    } finally {
      setPublishingMsg("");
    }
  };

  useEffect(() => {
    if (chatIsOpen) {
      setChatX(0);
    } else {
      setChatX("-320px");
    }
  }, [chatIsOpen]);

  const applyLoadedMessages = useCallback(
    (messagesArray, setter) => {
      setHasMoreMessages(messagesArray.length > messageLimit);
      setter(messagesArray.slice(0, messageLimit));
      loadingOlderRef.current = false;
      setLoadingOlder(false);
    },
    [messageLimit],
  );

  const handleLoadOlder = useCallback(() => {
    if (loadingOlderRef.current || loadingOlder || !hasMoreMessages) return;

    loadingOlderRef.current = true;
    setLoadingOlder(true);
    setMessageLimit((currentLimit) => currentLimit + PAGE_SIZE);
  }, [loadingOlder, hasMoreMessages]);

  useEffect(() => {
    attachmentsRef.current.forEach((attachment) => {
      if (attachment.localUrl) URL.revokeObjectURL(attachment.localUrl);
    });

    attachmentsRef.current = [];
    setAttachments([]);
    setUploadMap({});
    setPublishingMsg("");
    setShowAttachmentOptions(false);
    setChatPicker(null);
    setPendingLocation(null);
    setMessageLimit(PAGE_SIZE);
    setHasMoreMessages(true);
    loadingOlderRef.current = false;
    setLoadingOlder(false);
    setReplyingTo(null);
    setReplyMessageCache({});
    setPendingScrollMessageId(null);
    setFlashingMessageId(null);
    messageRefs.current = {};

    if (highlightTimeoutRef.current) {
      clearTimeout(highlightTimeoutRef.current);
      highlightTimeoutRef.current = null;
    }
  }, [activeChatKey]);

  useEffect(() => {
    return () => {
      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }
    };
  }, []);

  const unloadedReplyIdsKey = JSON.stringify([...new Set(activeMessages
    .map(message => message.repliedTo)
    .filter(id => typeof id === "string" && id && !activeMessages.some(message => message.id === id)))].sort());
  useEffect(() => {
    if (!activeMessagesCollection) return;
    const unsubscribers = JSON.parse(unloadedReplyIdsKey).map(messageId =>
      activeMessagesCollection.doc(messageId).onSnapshot(snapshot => {
        setReplyMessageCache(cache => ({...cache, [messageId]: snapshot.exists ? {id:snapshot.id,...snapshot.data()} : null}));
      }, error => { console.log("Could not load replied message:",error);setReplyMessageCache(cache=>({...cache,[messageId]:null})); }));
    return () => unsubscribers.forEach(unsubscribe=>unsubscribe());
  }, [activeChatKey, activeMessagesCollection, unloadedReplyIdsKey]);

  const handleReply = (message) => {
    setReplyingTo(message);

    requestAnimationFrame(() => {
      textareaRef.current?.focus();
    });
  };

  const scrollToMessage = (messageId) => {
    if (!messageId) return;
    setPendingScrollMessageId(messageId);
  };

  useEffect(() => {
    if (!pendingScrollMessageId) return;

    const targetMessage = activeMessages.find(
      (message) => message.id === pendingScrollMessageId,
    );
    const targetElement = messageRefs.current[pendingScrollMessageId];

    if (targetMessage && targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      setFlashingMessageId(pendingScrollMessageId);
      setPendingScrollMessageId(null);

      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }

      highlightTimeoutRef.current = setTimeout(() => {
        setFlashingMessageId(null);
        highlightTimeoutRef.current = null;
      }, 1400);

      return;
    }

    const replyWasDeleted =
      Object.prototype.hasOwnProperty.call(
        replyMessageCache,
        pendingScrollMessageId,
      ) && replyMessageCache[pendingScrollMessageId] === null;

    if (replyWasDeleted) {
      setPendingScrollMessageId(null);
      return;
    }

    if (hasMoreMessages && !loadingOlder) {
      handleLoadOlder();
      return;
    }

    if (!hasMoreMessages && !loadingOlder) {
      setPendingScrollMessageId(null);
    }
  }, [
    activeMessages,
    handleLoadOlder,
    hasMoreMessages,
    loadingOlder,
    pendingScrollMessageId,
    replyMessageCache,
  ]);

  useEffect(() => {
    const list = messagesListRef.current;
    const trigger = olderMessagesTriggerRef.current;

    if (!list || !trigger) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          handleLoadOlder();
        }
      },
      {
        root: list,
        rootMargin: "80px 0px 0px",
        threshold: 0.01,
      },
    );

    observer.observe(trigger);

    return () => observer.disconnect();
  }, [activeChatKey, handleLoadOlder]);

  // Read workspace messages.
  useEffect(() => {
    if (sendtomode !== "toworkspace" || !sendto) return;

    const unsub = db
      .collection("space")
      .doc(sendto)
      .collection("chats")
      .orderBy("created", "desc")
      .limit(messageLimit + 1)
      .onSnapshot(
        (querySnapshot) => {
          const messagesArray = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          applyLoadedMessages(messagesArray, setMsgs);
        },
        (error) => {
          console.log("Workspace messages listener error:", error);
          loadingOlderRef.current = false;
          setLoadingOlder(false);
        },
      );

    return () => unsub();
  }, [sendtomode, sendto, messageLimit, applyLoadedMessages]);

  // Read project messages.
  useEffect(() => {
    if (sendtomode !== "toproject" || !sendto || !selectedWorkspaceId) {
      return;
    }

    const unsub = db
      .collection("space")
      .doc(selectedWorkspaceId)
      .collection("stations")
      .doc(sendto)
      .collection("chats")
      .orderBy("created", "desc")
      .limit(messageLimit + 1)
      .onSnapshot(
        (querySnapshot) => {
          const messagesArray = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          applyLoadedMessages(messagesArray, setProjectMsgs);
        },
        (error) => {
          console.log("Project messages listener error:", error);
          loadingOlderRef.current = false;
          setLoadingOlder(false);
        },
      );

    return () => unsub();
  }, [
    selectedWorkspaceId,
    sendtomode,
    sendto,
    messageLimit,
    applyLoadedMessages,
  ]);

  // Read personal messages.
  useEffect(() => {
    if (sendtomode !== "toperson") return;
    if (!currentUser?.uid || !sendto) return;

    const activeConvId = getConversationId(currentUser.uid, sendto);
    let disposed = false,
      unsub;
    chatAction("ensureConversation", { otherUid: sendto })
      .then(() => {
        if (disposed) return;
        unsub = listenToConversationMessages(
          activeConvId,
          messageLimit + 1,
          (messagesArray) => {
            applyLoadedMessages(messagesArray, setPersonalMsgs);
          },
        );
      })
      .catch((error) => {
        if (!disposed) {
          setPersonalMsgs([]);
          console.error("Conversation:", error);
        }
      });
    return () => {
      disposed = true;
      unsub?.();
    };
  }, [sendtomode, currentUser?.uid, sendto, messageLimit, applyLoadedMessages]);

  const handleDeleteMessage = (msg) => {
    db.collection("space")
      .doc(currentSpaceId)
      .collection("chats")
      .doc(msg.id)
      .delete();
  };

  const handleDeleteProjectMessage = (msg) => {
    db.collection("space")
      .doc(currentSpaceId)
      .collection("stations")
      .doc(currentStationId)
      .collection("chats")
      .doc(msg.id)
      .delete();
  };

  const handleDeletePersonalMessage = (msg) => {
    const activeConvId = getConversationId(currentUser.uid, sendto);
    deleteConversationMessage(activeConvId, msg.id);
  };

  const generateConvRefId = () => {
    return currentUser.uid < sendto
      ? currentUser.uid + sendto
      : sendto + currentUser.uid;
  };

  const handleSendtomode = (mode) => {
    setSendtomode(mode);

    if (mode === "toworkspace") {
      setCurrentRecipient("");
      setSearchParams({ wschat: sendto });
    } else if (mode === "toproject") {
      setCurrentRecipient("");
      setSearchParams({ prchat: sendto });
    } else if (mode === "toperson") {
      const generatedConvRefId = generateConvRefId();
      setSearchParams({ dmchat: generatedConvRefId });
    }
  };

  const handleSendtoPerson = (member) => {
    setSendto(member?.uid);
    setButtonLook("personselected");
    setCurrentRecipient(member);
    setContactsOpen(false);

    const newConvId = getConversationId(currentUser.uid, member.uid);
    setSearchParams({ dmchat: newConvId });
    setSendtomode("toperson");
  };

  const handleChatHide = () => {
    SetChatIsOpen(!chatIsOpen);
  };

  const returnToCall = (target) => {
    if (!target) return;
    setSendtomode(target.sendtomode);
    setSendto(target.sendto);
    setSelectedWorkspaceId(target.selectedWorkspaceId);
    setSendtoWsId(target.sendtoWsId);
    setSelectedGroupName(target.selectedGroupName);
    setSelectedGroupColor(target.selectedGroupColor);
    setSelectedGroupIcon(target.selectedGroupIcon);
    setCurrentRecipient(target.currentrecipient);
    setButtonLook(
      target.sendtomode === "toperson" ? "personselected" : "nopersonselected",
    );
    SetChatIsOpen(true);
    setMeetingFullScreen(true);
    if (target.sendtomode === "toperson")
      setSearchParams({ dmchat: target.roomId });
    else if (target.sendtomode === "toworkspace")
      setSearchParams({ wschat: target.sendto });
    else
      setSearchParams({
        prchat: target.sendto,
        fromws: target.sendtoWsId || target.selectedWorkspaceId,
      });
  };

  const privacyAction = async (action) => {
    if (privacyBusy.current) return;
    privacyBusy.current = true;
    try {
      await action();
    } catch (error) {
      window.alert(error.message || "The action could not be completed.");
    } finally {
      privacyBusy.current = false;
    }
  };
  const groupMenuItems = (type, spaceId, stationId, name) => {
    const muted = currentUser?.mutedChats?.includes(
      chatKey(type, spaceId, stationId),
    );
    return [
      {
        key: "mute",
        label: muted ? "Unmute group chat" : "Mute group chat",
        onPress: () =>
          privacyAction(() => setChatMuted(type, spaceId, stationId, !muted)),
      },
      {
        key: "leave",
        label: "Block / leave group",
        onPress: () =>
          setPrivacyGroup({ type, spaceId, stationId, name, muted }),
      },
    ];
  };
  const personMenuItems = (person) => {
    const muted = currentUser?.mutedUsers?.includes(person.uid);
    const blocked = currentUser?.blockedUsers?.includes(person.uid);
    return [
      {
        key: "profile",
        label: "View profile",
        onPress: () => navigate(`/profile/${person.uid}`),
      },
      {
        key: "mute",
        label: muted ? "Unmute" : "Mute",
        onPress: () =>
          privacyAction(() =>
            (muted ? unMuteUser : muteUser)(currentUser.uid, person.uid),
          ),
      },
      {
        key: "block",
        label: blocked ? "Unblock" : "Block",
        onPress: () => {
          if (
            blocked ||
            window.confirm(
              "Block this person? This removes your connection and prevents direct messages and calls. Shared groups stay unchanged.",
            )
          )
            privacyAction(() =>
              (blocked ? unblockUser : blockUser)(currentUser.uid, person.uid),
            );
        },
      },
    ];
  };

  const handleWorkspaceSelect = (space) => {
    setSelectedWorkspaceId(space.spaceId);
    setSendtomode("toworkspace");
    setSendto(space.spaceId);
    setShowGroupSelect(false);
    setSelectedGroupName(space.name);
    setSelectedGroupColor(space.color);
    setSearchParams({ wschat: space.spaceId });
  };

  const handleProjectSelect = (project) => {
    setSendtomode("toproject");
    setButtonLook("nopersonselected");
    const stationId = project.stationId || project.id;
    const spaceId = project.fromSpaceId || project.spaceId;
    setSendto(stationId);
    setSendtoWsId(spaceId);
    setSelectedWorkspaceId(spaceId);
    setShowGroupSelect(false);
    setSelectedGroupName(project.name);
    setSelectedGroupIcon(project.emojicon);
    setSearchParams({ prchat: stationId, fromws: spaceId });
  };

  const renderOlderMessagesLoader = () => (
    <div ref={olderMessagesTriggerRef} className="ch__olderMessagesTrigger">
      {loadingOlder && (
        <div className="ch__olderMessagesLoader">
          <span className="ch__olderMessagesSpinner" />
          <span>Loading older messages...</span>
        </div>
      )}
    </div>
  );

  const getMessageText = (message) =>
    (message?.message ?? message?.text ?? "").trim();

  const getMessagePreview = (message) => {
    if (message?.moderationHidden) return "Removed by moderation.";
    const text = getMessageText(message);
    if (text) return text;

    const messageAttachments = Array.isArray(message?.attachments)
      ? message.attachments
      : [];

    if (messageAttachments.length > 1) {
      return `${messageAttachments.length} attachments`;
    }

    if (messageAttachments.length === 1) {
      const attachment = messageAttachments[0];

      if (attachment.kind === "image") return "Photo";
      if (attachment.kind === "video") return "Video";
      if (attachment.kind === "gif") return "GIF";
      if (attachment.kind === "sticker") return "Sticker";
      if (attachment.kind === "file") return attachment.name || "File";
      if (attachment.kind === "location") {
        return attachment.title || "Shared location";
      }
    }

    return "Message";
  };

  const getReplyMessage = (messageId) =>
    activeMessages.find((message) => message.id === messageId) ??
    replyMessageCache[messageId] ??
    null;

  const renderReplyReference = (message) => {
    if (message.moderationHidden || !message.repliedTo) return null;

    const repliedMessage = getReplyMessage(message.repliedTo);
    const repliedAuthor = users?.find(
      (user) => user.uid === repliedMessage?.from,
    );
    const repliedText = repliedMessage ? getMessagePreview(repliedMessage) : "";
    const replyWasDeleted =
      Object.prototype.hasOwnProperty.call(
        replyMessageCache,
        message.repliedTo,
      ) && replyMessageCache[message.repliedTo] === null;

    return (
      <button
        type="button"
        className="ch__replyReference"
        onClick={() => scrollToMessage(message.repliedTo)}
        disabled={replyWasDeleted}
        title={
          replyWasDeleted
            ? "The original message is unavailable"
            : "Go to replied message"
        }
      >
        <span className="ch__replyReference-label">replied to</span>

        {repliedMessage && (
          <Avatar
            src={
              repliedAuthor?.imageUrl ||
              repliedMessage.fromImage ||
              repliedMessage.fromImg
            }
            user={repliedAuthor}
          />
        )}

        <span className="ch__replyReference-text">
          {replyWasDeleted
            ? "Original message is unavailable"
            : repliedText
              ? repliedText.length > 42
                ? `${repliedText.slice(0, 42)}...`
                : repliedText
              : "Loading message..."}
        </span>
      </button>
    );
  };

  const deleteMessageForCurrentMode = (message) => {
    if (sendtomode === "toworkspace") {
      handleDeleteMessage(message);
    } else if (sendtomode === "toproject") {
      handleDeleteProjectMessage(message);
    } else if (sendtomode === "toperson") {
      handleDeletePersonalMessage(message);
    }
  };

  const messageActionItems = (message) => [
    {
      key: "react",
      label: "React / reply",
      icon: <BsEmojiSmileUpsideDown />,
      onPress: () => openMessagePicker(message),
    },
    {
      key: "reply",
      label: "Reply",
      icon: <HiOutlineArrowUturnLeft />,
      onPress: () => handleReply(message),
    },
    {
      key: "delete",
      label: "Delete",
      icon: <BsTrash />,
      onPress: () => deleteMessageForCurrentMode(message),
    },
    {
      key: "report",
      label: "Report",
      icon: <BsExclamationCircleFill />,
      onPress: () => {
        if (!activeMessagesCollection || !message?.id || !message?.from) return;
        setReportTarget({
          targetType: "message",
          targetId: message.id,
          targetPath: activeMessagesCollection.doc(message.id).path,
          reportedUserId: message.from,
          messageText: message.message ?? message.text ?? "",
          messageCreatedAt: message.created ?? message.createdAt ?? null,
          attachments: message.attachments ?? [],
        });
      },
    },
  ];

  useEffect(() => {
    if ([...(msgs || []), ...(projectMsgs || []), ...(personalMsgs || []), ...Object.values(replyMessageCache)].some(item => item?.id === replyingTo?.id && item?.moderationHidden === true)) setReplyingTo(null);
  }, [msgs, projectMsgs, personalMsgs, replyMessageCache, replyingTo?.id]);

  const renderMessageActions = (message) => message.moderationHidden ? null : (
    <div className="ch__messageActions">
      <TinyContextMenu
        ref={(menu) => {
          if (menu) messageActionMenuRefs.current[message.id] = menu;
          else delete messageActionMenuRefs.current[message.id];
        }}
        items={messageActionItems(message)}
        minWidth={170}
        customBtn={<IoEllipsisVertical size="1.1em" />}
      />
    </div>
  );

  const handleMessageContextMenu = (event, message) => {
    if (message.moderationHidden) { event.preventDefault(); return; }
    event.preventDefault();
    event.stopPropagation();
    messageActionMenuRefs.current[message.id]?.openAt(
      event.clientX,
      event.clientY,
    );
  };

  return (
    <motion.div
      className={!meetingFullScreen ? "allchat" : "allchatFS"}
      animate={{ marginRight: chatx }}
      initial={false}
      transition={{ ease: "easeOut" }}
      style={{
        zIndex: chatIsOpen ? "202" : "202",
      }}
    >
      {privacyGroup && (
        <GroupChatDialog
          group={privacyGroup}
          onClose={() => setPrivacyGroup(null)}
          onLeft={() => {
            setSendto(null);
            setSendtomode("");
            setSearchParams({});
          }}
        />
      )}

      {!meetingFullScreen && (
        <motion.div onClick={handleChatHide}>
          <button className={chatIsOpen ? "chat__hideMoved" : "chat__hide"}>
            {chatIsOpen ? (
              <div className="chat__exit__btn">
                <HiXMark size="3em" />
              </div>
            ) : (
              <div className="chat__exit__btn-flipped">
                <HiOutlineChatBubbleLeftEllipsis size="1.8em" />
              </div>
            )}
          </button>
        </motion.div>
      )}

      <div
        className={!meetingFullScreen ? "chat" : "chatFS"}
        style={{ display: chatIsOpen ? "flex" : "none" }}
      >
        <div className="meetingVideoChat-mockheader"> </div>

        <div
          className={
            !meetingFullScreen ? "meetingVideoChat" : "meetingVideoChatFS"
          }
          style={{ height: onCall ? "100%" : 70 }}
        >
          {/* One stable owner: hiding chat or selecting another chat does not
              unmount the active call. Its floating preview portals to body. */}
          {currentUser?.uid && (
            <GroupMeeting
              key={currentUser.uid}
              roomId={
                sendto &&
                ["toperson", "toworkspace", "toproject"].includes(sendtomode) &&
                (sendtomode !== "toworkspace" || callWorkspace) &&
                (sendtomode !== "toproject" || callProject)
                  ? sendtomode === "toperson"
                    ? convId
                    : sendto
                  : null
              }
              userId={currentUser?.uid}
              userName={currentUser?.userName}
              setOnCall={setOnCall}
              selectedGroupName={selectedGroupName}
              meetingFullScreen={meetingFullScreen}
              setMeetingFullScreen={setMeetingFullScreen}
              currentUser={currentUser}
              users={callRecipientIds.map((uid) => ({ uid }))}
              spaceId={
                sendtomode === "toworkspace"
                  ? sendto
                  : sendtomode === "toproject"
                    ? sendtoWsId || selectedWorkspaceId
                    : null
              }
              stationId={sendtomode === "toproject" ? sendto : null}
              callType={
                sendtomode === "toworkspace"
                  ? "workspace"
                  : sendtomode === "toproject"
                    ? "project"
                    : "private"
              }
              currentrecipient={currentrecipient}
              isChatOpen={chatIsOpen}
              onReturnToCall={returnToCall}
              chatTarget={{
                roomId: sendtomode === "toperson" ? convId : sendto,
                sendtomode,
                sendto,
                selectedWorkspaceId,
                sendtoWsId,
                selectedGroupName,
                selectedGroupColor,
                selectedGroupIcon,
                currentrecipient,
              }}
            />
          )}
        </div>

        <div
          className={
            meetingFullScreen
              ? "ch__breadcrumb-headerFS"
              : "ch__breadcrumb-header"
          }
        >
          {showInstantChat ? (
            <h5>
              {sendtomode.replace("to", "").replace("person", "One-on-One")}{" "}
              messages
            </h5>
          ) : (
            <h5></h5>
          )}

          <button onClick={() => setMeetingFullScreen(!meetingFullScreen)}>
            <BsFullscreenExit size="1.5em" />
          </button>

          <button onClick={() => setShowInstantChat(!showInstantChat)}>
            <IoMdChatboxes size="2.2em" />
          </button>
        </div>

        <div
          className={
            showInstantChat ? "ch__writeUpdate" : "ch__writeUpdateHidden"
          }
        >
          {sendtomode === "toworkspace" && (
            <div ref={messagesListRef} className="ch__writeUpdate-msgs">
              {msgs.map((msg) => (
                <div
                  key={msg.id}
                  ref={(element) => {
                    if (element) messageRefs.current[msg.id] = element;
                    else delete messageRefs.current[msg.id];
                  }}
                  className={`${
                    msg.from === currentUser?.uid
                      ? "ch__messageLine-Self"
                      : "ch__messageLine"
                  }${
                    flashingMessageId === msg.id
                      ? " ch__messageTargetFlash"
                      : ""
                  }`}
                  onContextMenu={(event) =>
                    handleMessageContextMenu(event, msg)
                  }
                >
                  <div className="ch__messagewithReaction">
                    {renderReplyReference(msg)}
                    <ChatMessageAttachments
                      attachments={msg.moderationHidden ? [] : msg.attachments}
                      stickerAvatar={
                        users?.find((user) => user.uid === msg.from)?.imgAvatar
                      }
                    />
                    <Message msg={msg} />
                    {!msg.moderationHidden && <ReactionSummary
                      docRef={db
                        .collection("space")
                        .doc(sendto)
                        .collection("chats")
                        .doc(msg.id)}
                      currentUser={currentUser}
                      isSelf={msg.from === currentUser?.uid}
                    />}
                  </div>

                  {renderMessageActions(msg)}
                </div>
              ))}

              {renderOlderMessagesLoader()}
            </div>
          )}

          {sendtomode === "toproject" && (
            <div ref={messagesListRef} className="ch__writeUpdate-msgs">
              {projectMsgs?.map((msg) => (
                <div
                  key={msg.id}
                  ref={(element) => {
                    if (element) messageRefs.current[msg.id] = element;
                    else delete messageRefs.current[msg.id];
                  }}
                  className={`${
                    msg.from === currentUser?.uid
                      ? "ch__messageLine-Self"
                      : "ch__messageLine"
                  }${
                    flashingMessageId === msg.id
                      ? " ch__messageTargetFlash"
                      : ""
                  }`}
                  onContextMenu={(event) =>
                    handleMessageContextMenu(event, msg)
                  }
                >
                  <div className="ch__messagewithReaction">
                    {renderReplyReference(msg)}
                    <ChatMessageAttachments
                      attachments={msg.moderationHidden ? [] : msg.attachments}
                      stickerAvatar={
                        users?.find((user) => user.uid === msg.from)?.imgAvatar
                      }
                    />
                    <Message msg={msg} />
                    {!msg.moderationHidden && <ReactionSummary
                      docRef={db
                        .collection("space")
                        .doc(selectedWorkspaceId)
                        .collection("stations")
                        .doc(sendto)
                        .collection("chats")
                        .doc(msg.id)}
                      currentUser={currentUser}
                      isSelf={msg.from === currentUser?.uid}
                    />}
                  </div>

                  {renderMessageActions(msg)}
                </div>
              ))}

              {renderOlderMessagesLoader()}
            </div>
          )}

          {sendtomode === "toperson" && (
            <div ref={messagesListRef} className="ch__writeUpdate-msgs">
              {personalMsgs?.map((msg) => {
                const isSelf = msg.from === currentUser?.uid;

                return (
                  <div
                    key={msg.id}
                    ref={(element) => {
                      if (element) messageRefs.current[msg.id] = element;
                      else delete messageRefs.current[msg.id];
                    }}
                    className={`${
                      isSelf ? "ch__messageLine-Self" : "ch__messageLine"
                    }${
                      flashingMessageId === msg.id
                        ? " ch__messageTargetFlash"
                        : ""
                    }`}
                    onContextMenu={(event) =>
                      handleMessageContextMenu(event, msg)
                    }
                  >
                    <div className="ch__messagewithReaction">
                      {renderReplyReference(msg)}
                      <ChatMessageAttachments
                        attachments={msg.moderationHidden ? [] : msg.attachments}
                        stickerAvatar={
                          users?.find((user) => user.uid === msg.from)
                            ?.imgAvatar
                        }
                      />
                      <Message
                        msg={{
                          ...msg,
                          message: msg.text,
                        }}
                      />

                      {!msg.moderationHidden && <ReactionSummary
                        docRef={db
                          .collection("conversations")
                          .doc(convId)
                          .collection("messages")
                          .doc(msg.id)}
                        currentUser={currentUser}
                        isSelf={isSelf}
                      />}
                    </div>

                    {renderMessageActions(msg)}
                  </div>
                );
              })}

              {renderOlderMessagesLoader()}
            </div>
          )}

          <div className="ch__writeUpdate-send">
            <div className="ch__textbox">
              <div className="ch__sendtomode-tabs">
                <div style={{ display: "flex", width: "100%" }}>
                  <button
                    className={
                      sendtomode === "toworkspace" || sendtomode === "toproject"
                        ? "ch__sendtomode-tab-active"
                        : "ch__sendtomode-tab"
                    }
                    onClick={() => {
                      setShowGroupSelect(!showGroupSelect);
                      setContactsOpen(false);
                    }}
                  >
                    {sendtomode === "toworkspace" ? (
                      <div className="chat_grpoption-selected">
                        <div
                          className="chat_grpoption_wsIcon"
                          style={{
                            background: selectedGroupColor,
                          }}
                        >
                          {selectedGroupName?.charAt(0)}
                        </div>
                        {selectedGroupName}
                      </div>
                    ) : sendtomode === "toproject" ? (
                      <div className="chat_grpoption-selected">
                        {selectedGroupIcon} {"  "}
                        {selectedGroupName}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          columnGap: "5px",
                        }}
                      >
                        <IoPeopleOutline size="1.4em" /> Group
                      </div>
                    )}
                  </button>

                  {showGroupSelect && (
                    <div className="chat_grpselect">
                      <div className="chat_grpselect_scroll">
                        {spaceData?.map((space) => (
                          <React.Fragment key={space.spaceId}>
                            <div
                              value={space.spaceId}
                              className={
                                sendto === space.spaceId
                                  ? "chat_grpoption-active"
                                  : "chat_grpoption"
                              }
                            >
                              <div className="chat_grpoption_info">
                                <div
                                  className="chat_grpoption_wsIcon"
                                  style={{
                                    background: space.color || "lightgray",
                                  }}
                                >
                                  {space?.name?.charAt(0)}
                                </div>
                                <button
                                  selected={
                                    selectedWorkspaceId === space.spaceId
                                  }
                                  style={{
                                    textDecoration: `underline 2px ${space.color}`,
                                    fontSize: "16px",
                                    fontWeight: "500",
                                  }}
                                  onClick={() => handleWorkspaceSelect(space)}
                                >
                                  {space?.name}
                                </button>
                              </div>
                              <div className="chat-group-actions">
                                {allProjects.some(
                                  (project) =>
                                    project.spaceId === space.spaceId,
                                ) && (
                                  <button
                                    type="button"
                                    className="chat-group-toggle"
                                    aria-label={`${projectOptionsWorkspaceId === space.spaceId ? "Collapse" : "Expand"} ${space.name} projects`}
                                    aria-expanded={
                                      projectOptionsWorkspaceId ===
                                      space.spaceId
                                    }
                                    onClick={() =>
                                      setProjectOptionsWorkspaceId((id) =>
                                        id === space.spaceId
                                          ? null
                                          : space.spaceId,
                                      )
                                    }
                                  >
                                    {projectOptionsWorkspaceId ===
                                    space.spaceId ? (
                                      <FiChevronDown />
                                    ) : (
                                      <FiChevronRight />
                                    )}
                                  </button>
                                )}
                                <TinyContextMenu
                                  items={groupMenuItems(
                                    "workspace",
                                    space.spaceId,
                                    null,
                                    space.name,
                                  )}
                                />
                              </div>
                            </div>

                            {projectOptionsWorkspaceId === space.spaceId && (
                              <motion.div
                                initial={{
                                  y: -50,
                                  height: "0px",
                                  opacity: 0,
                                }}
                                animate={{
                                  y: 0,
                                  height: "auto",
                                  opacity: 1,
                                }}
                                transition={{
                                  type: "ease-in-out",
                                  duration: 0.4,
                                }}
                              >
                                {projectOptions.map((project) => (
                                  <div
                                    key={JSON.stringify([
                                      space.spaceId,
                                      project.stationId || project.id,
                                    ])}
                                    value={project.stationId || project.id}
                                    className={
                                      sendto ===
                                      (project.stationId || project.id)
                                        ? "chat_grpsuboption-active"
                                        : "chat_grpsuboption"
                                    }
                                  >
                                    <button
                                      onClick={() =>
                                        handleProjectSelect(project)
                                      }
                                    >
                                      {project.emojicon} {project.name}
                                    </button>
                                    <TinyContextMenu
                                      items={groupMenuItems(
                                        "project",
                                        project.fromSpaceId || space.spaceId,
                                        project.stationId || project.id,
                                        project.name,
                                      )}
                                    />
                                  </div>
                                ))}
                              </motion.div>
                            )}
                          </React.Fragment>
                        ))}

                        {collabChatProjects.length > 0 && (
                          <div className="chat-collab-projects">
                            <button
                              type="button"
                              className="chat_grpoption chat-group-heading"
                              aria-expanded={collabProjectsOpen}
                              onClick={() =>
                                setCollabProjectsOpen((open) => !open)
                              }
                            >
                              <span className="chat_grpoption_info">
                                <AiOutlineShareAlt aria-hidden="true" />
                                <span>Collab Projects</span>
                              </span>
                              {collabProjectsOpen ? (
                                <FiChevronDown />
                              ) : (
                                <FiChevronRight />
                              )}
                            </button>
                            {collabProjectsOpen &&
                              collabChatProjects.map((project) => (
                                <div
                                  key={JSON.stringify([
                                    project.spaceId,
                                    project.stationId,
                                  ])}
                                  className={
                                    sendtomode === "toproject" &&
                                    sendto === project.stationId &&
                                    selectedWorkspaceId === project.spaceId
                                      ? "chat_grpsuboption-active"
                                      : "chat_grpsuboption"
                                  }
                                >
                                  <button
                                    onClick={() => handleProjectSelect(project)}
                                  >
                                    {project.emojicon || "📋"}{" "}
                                    {project.name || "Untitled project"}
                                  </button>
                                  <TinyContextMenu
                                    items={groupMenuItems(
                                      "project",
                                      project.fromSpaceId || project.spaceId,
                                      project.stationId,
                                      project.name,
                                    )}
                                  />
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div style={{ display: "flex", width: "100%" }}>
                  <div
                    className={
                      sendtomode === "toperson"
                        ? "ch__sendtomode-tab-active"
                        : "ch__sendtomode-tab"
                    }
                    onClick={() => {
                      handleSendtomode("toperson");
                      setContactsOpen(!contactsopen);
                      setShowGroupSelect(false);
                    }}
                  >
                    {sendtomode === "toperson" ? (
                      <button
                        className="ch__personselected"
                        onClick={() => {
                          handleSendtomode("toperson");
                          setContactsOpen(!contactsopen);
                          setShowGroupSelect(false);
                        }}
                      >
                        <Avatar
                          src={currentrecipient?.imageUrl}
                          user={currentrecipient}
                          onClick={() => {
                            setContactsOpen(!contactsopen);
                            setContactsOpen(false);
                          }}
                        />
                        {currentrecipient?.userName || "One-on-one"}
                      </button>
                    ) : (
                      <button
                        className="ch__personNonselected"
                        onClick={() => {
                          handleSendtomode("toperson");
                          setContactsOpen(!contactsopen);
                        }}
                      >
                        {sendtomode === "toperson" ? (
                          <Avatar
                            src={currentrecipient?.imageUrl}
                            user={currentrecipient}
                          />
                        ) : (
                          <div style={{ marginLeft: 5 }}>
                            <BsPersonCheck size={18} />
                          </div>
                        )}
                        One-on-one
                      </button>
                    )}
                  </div>

                  {sendtomode === "toperson" && (
                    <div>
                      {contactsopen && (
                        <div className="ch__selectperson">
                          <button
                            className="ch_people_group_header"
                            onClick={() =>
                              setConnectedUsersOpen(!connectedUsersOpen)
                            }
                          >
                            <h4>Connected users</h4>
                            {connectedUsersOpen ? (
                              <FiChevronDown />
                            ) : (
                              <FiChevronRight />
                            )}
                          </button>
                          <div
                            style={{
                              display: connectedUsersOpen ? "none" : "unset",
                            }}
                          >
                            {connectedUsers.map((member) => (
                              <div
                                key={member.uid}
                                member={member}
                                image={member.imageUrl}
                                className="ch__selectperson_item"
                              >
                                <button
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    columnGap: 10,
                                  }}
                                  onClick={() => handleSendtoPerson(member)}
                                >
                                  <Avatar src={member.imageUrl} user={member} />
                                  {member.userName}
                                </button>
                                <TinyContextMenu
                                  items={personMenuItems(member)}
                                />
                              </div>
                            ))}
                          </div>
                          <button
                            className="ch_people_group_header"
                            onClick={() => setCollabUsersOpen(!collabUsersOpen)}
                          >
                            <h4>Collaborating with</h4>
                            <button
                              type="button"
                              className="member-info-tip"
                              // onClick={(event) => {
                              //   event.preventDefault();
                              //   event.stopPropagation();
                              // }}
                              aria-label="These are the people from workspaces and projects that you are a member of."
                              data-tooltip-id="collabPeopleExplanation"
                              style={{
                                color: "var(--border1)",
                                background: "none",
                                border: 0,
                                padding: 3,
                                cursor: "help",
                              }}
                            >
                              <FaInfoCircle aria-hidden="true" />
                            </button>
                            <Tooltip
                              id="collabPeopleExplanation"
                              content="These are the people from workspaces and projects that you are a member of."
                              openEvents={{ mouseenter: true, focus: true }}
                              closeEvents={{ mouseleave: true, blur: true }}
                              style={{ maxWidth: 210, zIndex: 2000 }}
                            />
                            {collabUsersOpen ? (
                              <FiChevronDown />
                            ) : (
                              <FiChevronRight />
                            )}
                          </button>
                          <div
                            style={{
                              display: collabUsersOpen ? "unset" : "none",
                            }}
                          >
                            {memberData
                              ?.filter(
                                (member) => member.uid !== currentUser.uid,
                              )
                              .map((member) => (
                                <div
                                  key={member.uid}
                                  member={member}
                                  image={member.imageUrl}
                                  className="ch__selectperson_item"
                                >
                                  <button
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      columnGap: 10,
                                    }}
                                    onClick={() => handleSendtoPerson(member)}
                                  >
                                    <Avatar
                                      src={member.imageUrl}
                                      user={member}
                                    />
                                    {member.userName}
                                  </button>
                                  <TinyContextMenu
                                    items={personMenuItems(member)}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="ch__writeUpdate-message">
                <form onSubmit={handleSubmit} id="MessageForm">
                  <textarea
                    onChange={(e) => setChatMessage(e.target.value)}
                    ref={textareaRef}
                    placeholder="Write a message"
                    value={chatmessage}
                  />
                </form>

                <div className="ch__writeUpdate-buttongroup">
                  <div className="ch__writeUpdate-buttongroup-sub">
                    <div
                      ref={attachmentControlRef}
                      className="ch__attachmentControl"
                    >
                      <button
                        type="button"
                        className="ch__attachmentTrigger"
                        onClick={() =>
                          setShowAttachmentOptions(!showAttachmentOptions)
                        }
                        disabled={!!publishingMsg}
                        title="Add attachment"
                      >
                        <IoAttach />
                      </button>

                      {showAttachmentOptions && (
                        <div className="ch__attachmentMenu">
                          <button
                            type="button"
                            onClick={() => {
                              setShowAttachmentOptions(false);
                              imageInputRef.current?.click();
                            }}
                          >
                            <IoImageOutline />
                            Add photo
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setShowAttachmentOptions(false);
                              videoInputRef.current?.click();
                            }}
                          >
                            <IoVideocamOutline />
                            Add video
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setShowAttachmentOptions(false);
                              fileInputRef.current?.click();
                            }}
                          >
                            <IoDocumentAttachOutline />
                            Add file
                          </button>
                          <button type="button" onClick={shareLocation}>
                            <IoLocationOutline />
                            Share location
                          </button>
                        </div>
                      )}

                      <input
                        ref={imageInputRef}
                        type="file"
                        accept="image/*"
                        multiple
                        hidden
                        onChange={handleImageFiles}
                      />
                      <input
                        ref={videoInputRef}
                        type="file"
                        accept="video/mp4,.mp4"
                        hidden
                        onChange={handleVideoFile}
                      />
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                        hidden
                        onChange={handleFile}
                      />
                    </div>

                    <div className="ch__EmojiIcon">
                      <button
                        ref={composerPickerButtonRef}
                        type="button"
                        className="ch__EmojiPick"
                        onClick={openComposerPicker}
                        disabled={!!publishingMsg}
                        title="Emoji, stickers and GIFs"
                      >
                        <BsEmojiSmileUpsideDown size="1.2em" />
                      </button>
                    </div>
                  </div>

                  <div className="ch__writeUpdate-btn">
                    <RetroButton
                      type="submit"
                      form="MessageForm"
                      disabled={!!publishingMsg}
                    >
                      <FaPaperPlane size="1.5em" />
                    </RetroButton>
                  </div>
                </div>
              </div>

              <PendingChatAttachments
                attachments={attachments}
                uploadMap={uploadMap}
                onMove={moveAttachment}
                onRemove={removeAttachment}
              />

              {publishingMsg && (
                <div className="ch__attachmentPublishing">{publishingMsg}</div>
              )}

              {replyingTo && (
                <div className="ch__replyComposer">
                  <span className="ch__replyComposer-label">replying to</span>

                  <div className="ch__replyComposer-message">
                    <Avatar
                      src={
                        users?.find((user) => user.uid === replyingTo.from)
                          ?.imageUrl ||
                        replyingTo.fromImage ||
                        replyingTo.fromImg
                      }
                      user={users?.find((user) => user.uid === replyingTo.from)}
                    />

                    <span>
                      {getMessagePreview(replyingTo).length > 45
                        ? `${getMessagePreview(replyingTo).slice(0, 45)}...`
                        : getMessagePreview(replyingTo)}
                    </span>
                  </div>

                  <button
                    type="button"
                    className="ch__replyComposer-close"
                    onClick={() => setReplyingTo(null)}
                    title="Cancel reply"
                  >
                    <HiXMark />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ChatReactionPicker
        open={!!chatPicker}
        anchorRect={chatPicker?.anchorRect}
        initialTab={chatPicker?.initialTab || "emoji"}
        onClose={() => setChatPicker(null)}
        onSelectEmoji={handlePickerEmoji}
        onSelectSticker={handlePickerSticker}
        onSelectGif={handlePickerGif}
        emojisOn
        stickersOn
        gifsOn
        renderSticker={(stickerKey) => (
          <Peep
            useravatar={currentUserAvatar}
            size={96}
            width={96}
            height={96}
            borderRadius={48}
            borderWidth={0}
            overflow="hidden"
            backgroundColor="#F5F5F5"
            flip
            reaction={stickerKey}
            reactionInteractive={false}
          />
        )}
      />

      {reportTarget && (
        <Report
          reportTitle="Report message"
          onClose={() => setReportTarget(null)}
          onSubmit={(reason, details) =>
            createReport(currentUser?.uid, reportTarget, reason, details)
          }
        />
      )}

      <LocationAttachmentModal
        location={pendingLocation}
        onCancel={() => setPendingLocation(null)}
        onConfirm={confirmLocation}
      />
    </motion.div>
  );
}

export default Chat;
